import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/shipment-txn", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/shipment-txn/csv", params);
};

const upsert = data => {
  return restApi.post("/api/shipment-txn/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/shipment-txn/${ids}`);
};

const shipmentTxnService = {
  getAll,
  getAllForCSV,
  upsert,
  remove
};

export default shipmentTxnService;